function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9874 6.2625L11.8949 8.355C11.6549 8.595 11.8199 9 12.1574 9H13.4999C13.4999 11.4825 11.4824 13.5 8.9999 13.5C8.4074 13.5 7.8299 13.3875 7.3124 13.17C7.0424 13.0575 6.7349 13.14 6.5324 13.3425C6.1499 13.725 6.2849 14.37 6.7874 14.5725C7.4699 14.85 8.2199 15 8.9999 15C12.3149 15 14.9999 12.315 14.9999 9H16.3424C16.6799 9 16.8449 8.595 16.6049 8.3625L14.5124 6.27C14.3699 6.12 14.1299 6.12 13.9874 6.2625ZM4.4999 9C4.4999 6.5175 6.5174 4.5 8.9999 4.5C9.5924 4.5 10.1699 4.6125 10.6874 4.83C10.9574 4.9425 11.2649 4.86 11.4674 4.6575C11.8499 4.275 11.7149 3.63 11.2124 3.4275C10.5299 3.15 9.7799 3 8.9999 3C5.6849 3 2.9999 5.685 2.9999 9H1.6574C1.3199 9 1.1549 9.405 1.3949 9.6375L3.4874 11.73C3.6374 11.88 3.8699 11.88 4.0199 11.73L6.1124 9.6375C6.3449 9.405 6.1799 9 5.8424 9H4.4999Z"
});

function SvgRandomizeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#F4536E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomizeIcon);
export default __webpack_public_path__ + "static/media/RandomizeIcon.e41823ec.svg";
export { ForwardRef as ReactComponent };